import debounce from 'lodash/debounce';
import { useState, useMemo } from 'react';
const UPDATE_TIMEOUT_MS = 100;
export default function useZoom(params) {
  const {
    defaultZoomLevel = 100
  } = params || {};
  const {
    0: zoomLevel,
    1: setZoomLevel
  } = useState(defaultZoomLevel); // Debounce zoom level updates

  const adjustZoomLevel = useMemo(() => debounce(setZoomLevel, UPDATE_TIMEOUT_MS), []);
  return {
    zoomLevel,
    adjustZoomLevel
  };
}